import { format, parseISO } from "date-fns";

export const LIMIT = 20;

export const SOURCE_FILTER_OPTIONS = [
  { value: "agency_direct", label: "Direct" },
];

export const listParam = (value) =>
  value ? value.split(",").filter(Boolean) : [];

export const valuesLabel = (labels) =>
  labels.length > 2 ? `${labels[0]} +${labels.length - 1}` : labels.join(", ");

export const peopleLabel = (names, ids) => {
  if (names.length) return valuesLabel(names);
  const count = String(ids).split(",").filter(Boolean).length;
  return `${count} ${count === 1 ? "person" : "people"}`;
};

export const optionLabel = (options, value) =>
  options.find((o) => o.value === value)?.label || value;

export const day = (d) => (d ? format(d, "yyyy-MM-dd") : "");

export const dateParam = (params, key) => {
  const v = params.get(key);
  return v ? parseISO(v) : null;
};

/** How far ahead an upcoming date range (e.g. Launch Date) can be picked. */
export const UPCOMING_MONTHS = 3;
